(function () {
  var FEATURE = [{ name: 'consent-tracking-api', version: '0.1' }];
  var COOKIE = 'todly_consent';
  var YEAR_SECONDS = 31536000;
  var HALF_YEAR_SECONDS = 15552000;
  var CONSENT_COUNTRIES = {
    AT: true,
    BE: true,
    BG: true,
    HR: true,
    CY: true,
    CZ: true,
    DK: true,
    EE: true,
    FI: true,
    FR: true,
    DE: true,
    GR: true,
    HU: true,
    IS: true,
    IE: true,
    IT: true,
    LV: true,
    LI: true,
    LT: true,
    LU: true,
    MT: true,
    NL: true,
    NO: true,
    PL: true,
    PT: true,
    RO: true,
    SK: true,
    SI: true,
    ES: true,
    SE: true,
    CH: true,
    GB: true
  };
  var banner;
  var privacy = null;
  var deciding = false;
  var pendingConsent = null;
  var loadingPrivacy = false;
  var privacyCallbacks = [];

  function readDecision() {
    var match = document.cookie.match(/(?:^|;\s*)todly_consent=([^;]+)/);
    if (!match) return null;
    try {
      return JSON.parse(decodeURIComponent(match[1]));
    } catch (e) {
      return null;
    }
  }

  function writeDecision(decision) {
    var maxAge = decision === 'declined' ? HALF_YEAR_SECONDS : YEAR_SECONDS;
    var value = encodeURIComponent(JSON.stringify({ decision: decision, ts: Date.now() }));
    var secure = location.protocol === 'https:' ? ';Secure' : '';
    document.cookie = COOKIE + '=' + value + ';path=/;max-age=' + maxAge + ';SameSite=Lax' + secure;
  }

  function withinSeconds(ts, seconds) {
    return ts && Date.now() - ts < seconds * 1000;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function show(moveFocus) {
    if (!banner) return;
    banner.hidden = false;
    requestAnimationFrame(function () {
      banner.classList.add('cookie-banner--visible');
    });
    if (moveFocus) {
      var first = banner.querySelector('[data-cookie-reject], [data-cookie-accept]');
      if (first) first.focus();
    }
  }

  function hide() {
    if (!banner) return;
    banner.classList.remove('cookie-banner--visible');
    if (prefersReducedMotion()) {
      banner.hidden = true;
      return;
    }
    var done = function () {
      banner.hidden = true;
      banner.removeEventListener('transitionend', done);
    };
    banner.addEventListener('transitionend', done);
    setTimeout(done, 500);
  }

  function applyLocalDecision(granted, hideAfter) {
    writeDecision(granted ? 'accepted' : 'declined');
    if (hideAfter !== false) hide();
  }

  function isFreshDecision(rec) {
    if (!rec) return false;
    if (rec.decision === 'declined') return withinSeconds(rec.ts, HALF_YEAR_SECONDS);
    if (rec.decision === 'accepted') return withinSeconds(rec.ts, YEAR_SECONDS);
    return false;
  }

  function loadPrivacy(callback) {
    if (privacy) {
      callback(privacy);
      return;
    }

    privacyCallbacks.push(callback);
    if (loadingPrivacy) return;
    loadingPrivacy = true;

    function flush(cp) {
      var callbacks = privacyCallbacks.slice();
      privacyCallbacks = [];
      loadingPrivacy = false;
      callbacks.forEach(function (cb) {
        cb(cp);
      });
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(FEATURE, function (error) {
        if (!error && window.Shopify.customerPrivacy) {
          onPrivacyReady(window.Shopify.customerPrivacy);
          flush(window.Shopify.customerPrivacy);
          return;
        }
        flush(null);
      });
    } else {
      flush(null);
    }
  }

  function commitConsent(granted, hideAfter) {
    var fallback;
    var result;

    if (deciding) return;

    applyLocalDecision(granted, hideAfter);

    if (!privacy || typeof privacy.setTrackingConsent !== 'function') {
      return;
    }

    function finish() {
      if (!deciding) return;
      deciding = false;
      if (fallback) clearTimeout(fallback);
    }

    deciding = true;
    fallback = setTimeout(finish, 8000);

    try {
      result = privacy.setTrackingConsent(
        {
          analytics: granted,
          marketing: granted,
          preferences: granted,
          sale_of_data: granted
        },
        finish
      );
      if (result && typeof result.then === 'function') {
        result.then(finish, finish);
      }
    } catch (e) {
      finish();
    }
  }

  function setConsent(granted) {
    if (deciding) return;
    if (!privacy) {
      pendingConsent = granted;
      applyLocalDecision(granted, true);
      loadPrivacy(function () {
        if (pendingConsent === null) return;
        var queued = pendingConsent;
        pendingConsent = null;
        if (privacy) commitConsent(queued, false);
      });
      return;
    }

    commitConsent(granted, true);
  }

  function hasConsentDecision(consent) {
    if (!consent) return false;
    var values = [consent.analytics, consent.marketing, consent.preferences, consent.sale_of_data];
    for (var i = 0; i < values.length; i++) {
      if (values[i] === 'yes' || values[i] === 'no') return true;
    }
    return false;
  }

  function callPrivacy(method) {
    if (!privacy || typeof privacy[method] !== 'function') return null;
    try {
      return privacy[method]();
    } catch (e) {
      return null;
    }
  }

  function isConsentRegion() {
    var region = callPrivacy('getRegion');
    if (!region && window.Shopify && window.Shopify.country) region = window.Shopify.country;
    if (!region && banner) region = banner.getAttribute('data-country-code');
    if (!region || typeof region !== 'string') return false;
    return CONSENT_COUNTRIES[region.slice(0, 2).toUpperCase()] === true;
  }

  function processingRequiresConsent() {
    var methods = ['analyticsProcessingAllowed', 'marketingAllowed', 'preferencesProcessingAllowed'];
    for (var i = 0; i < methods.length; i++) {
      if (callPrivacy(methods[i]) === false) return true;
    }
    return false;
  }

  function shouldDisplay() {
    var rec = readDecision();
    if (isFreshDecision(rec)) return false;
    if (privacy && hasConsentDecision(callPrivacy('currentVisitorConsent'))) return false;
    if (callPrivacy('shouldShowBanner') === true) return true;
    if (processingRequiresConsent()) return true;
    if (isConsentRegion()) return true;
    return false;
  }

  function syncStoredDecision() {
    var rec = readDecision();
    if (!privacy || !isFreshDecision(rec)) return false;
    if (hasConsentDecision(callPrivacy('currentVisitorConsent'))) return false;
    commitConsent(rec.decision === 'accepted', false);
    return true;
  }

  function bindPrivacyEvents() {
    document.addEventListener('visitorConsentCollected', function (event) {
      var detail = event.detail || {};
      var analytics = detail.analyticsAllowed;
      var marketing = detail.marketingAllowed;
      var preferences = detail.preferencesAllowed;

      if (analytics === undefined) analytics = detail.analyticsProcessingAllowed;
      if (preferences === undefined) preferences = detail.preferencesProcessingAllowed;

      if (analytics === true && marketing === true && preferences === true) {
        writeDecision('accepted');
        hide();
      } else if (analytics === false || marketing === false || preferences === false) {
        writeDecision('declined');
        hide();
      }
    });
  }

  function bindControls() {
    var accept = banner.querySelector('[data-cookie-accept]');
    var reject = banner.querySelector('[data-cookie-reject]');
    if (accept) accept.addEventListener('click', function () { setConsent(true); });
    if (reject) reject.addEventListener('click', function () { setConsent(false); });
    banner.addEventListener('click', function (e) {
      if (e.target === banner) setConsent(true);
    });
    document.querySelectorAll('[data-cookie-reopen]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        show(true);
      });
    });
  }

  function onPrivacyReady(cp) {
    privacy = cp;
    if (pendingConsent !== null) return;
    if (syncStoredDecision()) return;
    if (shouldDisplay()) {
      show(false);
    } else if (banner && banner.classList.contains('cookie-banner--visible')) {
      hide();
    }
  }

  function boot() {
    banner = document.querySelector('[data-cookie-banner]');
    if (!banner) return;
    bindControls();
    bindPrivacyEvents();

    var fallback = setTimeout(function () {
      if (!privacy && shouldDisplay()) show(false);
    }, 1500);

    loadPrivacy(function (cp) {
      clearTimeout(fallback);
      if (!cp && shouldDisplay()) show(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
